const radio = require('lib/radio')
const log = require('log').create('funnel') // eslint-disable-line

/*

funnels

// usage
const funnels = require('lib/funnels')

// initialize funnels (this is handled by index.browser and index.server)
funnels.initialize(contextData.globals.funnels)

// get a funnel
const funnel = funnels.get('some_funnel_name')

// use a funnel
funnel.choice // static property containing the value of the funnel
funnel.is(value) // returns true or false if the funnel value matches the given value

*/

// instances of this class are returned by funnels.get
class Funnel {

    constructor(name, choice) {
        this.name = name
        this.choice = choice
    }

    is(choice) {
        return this.choice === choice
    }

    isNot(choice) {
        return ! this.is(choice)
    }

    // helper for exposing a funnel into html templates
    serialize() {
        const data = {
            name: this.name,
            choice: this.choice,
            is: {
                control: false,
                experiment: false,
            },
            isNot: {
                control: true,
                experiment: true,
            },
        }
        data.is[this.choice] = true
        data.isNot[this.choice] = false
        return data
    }

}

const funnels = {

    // exporting for tests
    Funnel,

    metrics_sent: {},

    initialize(funnel_data) {
        this.funnels = funnel_data
    },

    // for testing, mostly
    reset() {
        delete this.funnels
    },

    get(funnel_name) {
        if (! this.funnels) throw new Error('Funnels have not been initialized yet!')

        const funnel_value = this.getFunnelValue(funnel_name)

        this.sendMetric(funnel_name, funnel_value)

        return new Funnel(funnel_name, funnel_value)
    },

    getFunnelValue(funnel_name) {
        const funnel_value = (
            this.funnels
            && this.funnels[funnel_name]
            && this.funnels[funnel_name].choice
        )

        if (typeof funnel_value !== 'undefined') return funnel_value

        throw new Error(`Funnel ${funnel_name} not configured in this environment`)
    },

    getFunnelSummary() {
        if (! this.funnels) throw new Error('Funnels have not been initialized yet!')

        const funnel_summary = {}
        Object.keys(this.funnels).forEach(name => {
            funnel_summary[name] = funnels.getFunnelValue(name)
        })

        return funnel_summary
    },

    // fire a metric for a given funnel_name and funnel_value
    // only once, and only in the browser
    sendMetric(funnel_name, funnel_value) {
        if (typeof window === 'undefined') return
        if (this.metrics_sent[funnel_name]) return

        radio.abtest.trigger(funnel_name, {
            test_group: funnel_value,
        })
        this.metrics_sent[funnel_name] = true
    },

}


module.exports = funnels
